"use client"

import { useState, useEffect } from "react"
import "./LiveCounter.scss"

const LiveCounter = () => {
  const [count, setCount] = useState(125847)

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev + Math.floor(Math.random() * 3) + 1)
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="live-counter">
      <div className="counter-content">
        <div className="counter-number">{count.toLocaleString()}</div>
        <p className="counter-text">Cakoi Served This Month</p>
        <div className="counter-indicator">
          <div className="pulse-dot"></div>
          <span className="indicator-text">Live Counter</span>
        </div>
      </div>
    </div>
  )
}

export default LiveCounter
